import { TableColumnMeta } from "ds/components/Table/types";

export const AI_TABLE_STORAGE_KEY = "aiIntegrationsTableStorageKey";
export const AI_TABLE_FILTERS_STORAGE_KEY = "aiIntegrationsFiltersStorageKey";

export enum AI_COLUMN_ID {
  PROVIDER = "PROVIDER",
  NAME = "NAME",
  MODEL = "MODEL",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const AI_TABLE_COLUMNS_CONFIG: Record<AI_COLUMN_ID, TableColumnMeta> = {
  [AI_COLUMN_ID.PROVIDER]: {
    id: AI_COLUMN_ID.PROVIDER,
    title: "Provider",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: 150,
    allowsSorting: true,
    resizable: false,
    canHide: true,
    configurable: true,
  },
  [AI_COLUMN_ID.NAME]: {
    id: AI_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [AI_COLUMN_ID.MODEL]: {
    id: AI_COLUMN_ID.MODEL,
    title: "Model",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [AI_COLUMN_ID.SPACE]: {
    id: AI_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [AI_COLUMN_ID.DROPDOWN]: {
    id: AI_COLUMN_ID.DROPDOWN,
    title: "More actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<AI_COLUMN_ID, string> = {
  [AI_COLUMN_ID.PROVIDER]: "provider",
  [AI_COLUMN_ID.NAME]: "name",
  [AI_COLUMN_ID.MODEL]: "model",
  [AI_COLUMN_ID.SPACE]: "space",
  [AI_COLUMN_ID.DROPDOWN]: "dropdown",
};
